import { Swiper } from 'swiper/core';

import './styles.scss';
const initProductGridSlider = function() {
  let sliderOptions = { slidesPerView: 'auto' };

  if (document.documentElement.clientWidth	>= 768) {
    sliderOptions['slidesPerView'] = 4;
  }

  new Swiper('.product-grid-slider', {
    preloadImages: true,
    ...sliderOptions
  });
};

export default initProductGridSlider;
